import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';
import { LineHeights } from '../../../../../types/common/types';

export const templateProductTrialsOverlayWindow = document.createElement('template');

templateProductTrialsOverlayWindow.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id="overlay-content">
    <img id="in-product-trials-overlay-window-image"/>

    <gz-title id="in-product-trials-overlay-window-title" fontSize="18"></gz-title>
    <gz-text id="in-product-trials-overlay-window-text" fontSize="13" lineHeight="${LineHeights.SMALL}"></gz-text>

    <gz-button id="in-product-trials-overlay-window-button1"></gz-button>
    <gz-button id="in-product-trials-overlay-window-button2"></gz-button>
    <gz-button id="in-product-trials-overlay-window-button3" class="hidden"></gz-button>
  </div>
`;
